import ReactGA from "react-ga4";
import { canSendToGA } from "./analiticsConfigByFacility";

export const initGA = (trackingId: string) => {
  if (!trackingId) {
    console.warn("Google Analytics Tracking ID is missing");
    return;
  }
  ReactGA.initialize(trackingId);
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: document.title });
};

export const addToCart = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "." });
};

export const gaEvent = (
  facilityIds: string,
  category: string,
  action: string,
  parameters: Record<string, any> = {},
  label?: string
) => {
  if (canSendToGA(facilityIds)) {
    ReactGA.event({
      category,
      action,
      label,
      nonInteraction: false,
      ...parameters,
    });
  }
};
